import { useTranslation } from "react-i18next";
import { DateTime } from 'luxon';
import { formatNumber } from '@utils/formatNumber';
import { formatPercentCell } from '../../../../utils/formatPercent';
import styles from './ChartTooltip.module.css';

interface ITooltipRow {
  name?: string;
  value?: number;
  color?: string;
  payload?: { startIso?: string; productivity?: number | null };
}

interface IChartTooltipProps {
  active?: boolean;
  payload?: ITooltipRow[];
  locale: string;
}

export function ChartTooltip({ active, payload, locale }: IChartTooltipProps) {
  const { t } = useTranslation();
  if (!active || !payload || payload.length === 0) return null;

  const startIso = payload[0]?.payload?.startIso;
  // `null`/absent = the bucket had no measured labour to divide by.
  const productivity = payload[0]?.payload?.productivity ?? null;
  
  return (
    <div className={styles.tooltip}>
      <div className={styles.tooltipHeader}>
        {startIso ? DateTime.fromISO(startIso, { zone: 'utc' }).setLocale(locale).toFormat('DD') : ''}
      </div>
      <div className={styles.tooltipBody}>
        {payload.map((row) => (
          <div key={row.name} className={styles.tooltipRow}>
            <span className={styles.tooltipDot} style={{ background: row.color }} aria-hidden="true" />
            <span className={styles.tooltipText}>
              {row.name}: {row.value != null ? formatNumber(row.value) : '—'}
            </span>
          </div>
        ))}
        <div className={styles.tooltipRow}>
          <span className={styles.tooltipText}>
            {t('productivity.expected.tooltipProductivity')}:{' '}
            {formatPercentCell(productivity)}
          </span>
        </div>
      </div>
    </div>
  );
}